import { Component, OnInit, OnDestroy, Input, HostListener, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ResourceService } from 'sce-core';
import { UserService } from '../../../../core/security/user.service';
import { NavigationService } from '../../../../core/navigation.service';
import { ActivatedRoute } from '@angular/router';
import { LeftPanelService } from '../../../../layout/home/services/left-panel.service';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { UserPreferenceService } from '../../../../layout/home/services/user-preference.service';
import { FormPageConfig } from '../../../../shared/models/form-page-config';
import { SearchService } from '../../../../shared/search/search.service';
import { AlertService } from 'sce-core';
import { ConfirmDialogService } from 'sce-core';
import { LFDynamicWidgetConfig } from '../../../../shared/models/lf-dynamic-widget-config';
import { TablePreference } from '../../../../shared/search/models/table-preference.model';
import { SharedServiceRegistry } from '../../../../shared/shared-service-registry';
import { SearchableEntityServiceFactory } from '../../../../shared/services/searchable-entity/searchable-entity-service-factory';
import { SearchableEntityConfig } from '../../../../shared/models/searchable-entity-config';
import { DetailViewKeyEventHandlerService } from '../../../../shared/services/detail-view-key-event-handler.service';
import { UserPreferenceEvent, DELETE_FAVOURITE, ADD_FAVOURITE } from '../../../../shared/models/user-favourite-event';
import { NEW_SEARCH_EVENT, NEW_ROW_EVENT, PAGE_OVERFLOW_EVENT, ITEM_CLICK_EVENT, DELETE_ROW_EVENT } from '../../../../shared/search/search-constants';
import { SearchEvent } from '../../../../shared/search/models/search-event';
import { InventoryReplenishDataService } from '../services/inventory-replenish-data.service';
import { InventoryReplenishButtonService } from '../services/inventory-replenish-button.service';
import { InventoryReplenishDataEditorService } from '../services/inventory-replenish-data-editor.service';
import { AccordionConfig } from '../../../../shared/models/accordion-config';
import { SearchParams } from '../../../../shared/search/models/search-params.model';
import { DataTableConfig } from '../../../../shared/search/models/data-table-config';
import { ButtonItem } from '../../../../shared/button/button.model';
import { SearchStatus } from '../../../../shared/search/models/search-status.model';
import { PagedData } from '../../../../shared/search/models/paged-data.model';
import { InventoryReplenishActionService } from '../services/inventory-replenish-action.service';

@Component({
  selector: 'lfwms-searchable-entity-inventory-static-form',
  templateUrl: './inventory-static-form-page.component.html',
  styleUrls: ['./inventory-static-form-page.component.css']
})
export class InventoryStaticFormComponent implements OnInit, OnDestroy {

  @Input() public serviceFactory: SearchableEntityServiceFactory;

  // Generic services
  protected dataService: InventoryReplenishDataService;
  protected buttonService: InventoryReplenishButtonService;
  protected actionService: InventoryReplenishActionService;
  protected dataEditor: InventoryReplenishDataEditorService;

  // Service to maintain Master Data for Primary & Secondary Accordions in the Details Page
  protected primarySearchService: SearchService;
  // Search Service which is passed as input to Data Table inside Details Accordion
  public detailsSearchService: SearchService;

  // the column group user preference
  public columnGroupUserPreference: any;

  /* Map Object <K,V> to maintain Cell Metadata [ for Primary & Secondary Accordions ] in the Details Page.
     This metadata is readily available from the Data Service and hence no fresh fetch is required. */
  public metadataMap: any;
  /* Map Object <K,V> to maintain Cell Data [ for Primary & Secondary Accordions ] in the Details Page.
     A fresh fetch is fired each time against a Receipt Key (dataService.primarySelectedDocument) from ngOnInit() */
  public cellDataMap: any;

  private keyEventHandler: DetailViewKeyEventHandlerService;

  // public isLoading: boolean = false;

  // public isPrimaryDataLoaded: boolean = false;

  // variable to store all object level sunscriptions. This will be unsubscribed on component destroy
  private subscriptionLists: Array<Subscription>;
  // Flag to show/hide Details Accordion
  // public showDetailsSection: boolean = false;
  // Flag to expand/collapse Details Accordion
  public expandDetailsSection: boolean = true;

  public entityConfig: SearchableEntityConfig;
  public showBreadcrumbLabel = false;
  public selectedValue: String;

  public primaryAccordion: AccordionConfig;
  // public secondaryAccordionList: Array<AccordionConfig>;
  // flag indicating if the state should be retained
  private retainState: boolean;
  // variables for smooth scrolling of floating menu
  private floatingMenuOffset;
  public isStickyFloatingMenu: boolean;
  private previousScroll = 0;
  private isScrollDown = false;

  protected navService: NavigationService;
  protected resourceService: ResourceService;
  protected userService: UserService;
  // private activatedRoute: ActivatedRoute;
  protected alertService: AlertService;
  protected confirmDialogService: ConfirmDialogService;
  protected userPreferenceService: UserPreferenceService;
  public tablePreference: TablePreference;
  public favouriteIconFlag: boolean = false;
  protected userPreferenceEventSubscription: Subscription;

  public pageConfig: FormPageConfig;
  public tableFlag;
  public expandPrimaryAccordion: boolean = true;
  public expandDetailsAccordion: boolean = true;
  public tooltipPosition: string = 'bottom';
  public tooltipMessage: string = 'Add to Favourites';
  public detailButtonsOnEdit: any;

  public selectedTab: any = 0;
  public tabHeaders: Array<string> = ['lbl_detail', 'lbl_replenishment_log'];
  public detailButtons: any;


  public columnGroupWidgetList: Array<LFDynamicWidgetConfig>;
  public title: string = '';

  @ViewChild('floatingMenuId', { read: ElementRef }) navbarif: ElementRef;
  @HostListener('window:scroll', ['$event'])
  onScroll(event) {
    this.floatingMenuOffset = this.navbarif.nativeElement.offsetTop;
    if (this.previousScroll < window.pageYOffset) {
      this.isScrollDown = true;
    } else {
      this.isScrollDown = false;
    }
    this.previousScroll = window.pageYOffset;
    // floating menu is getting fixed when height is 40 px from top, that is why we are adding/subtracting 39 px
    // to the offset. So that there wont be any sudden jumps during scrolling.
    if ((window.pageYOffset + (this.isScrollDown ? 39 : -39)) >= (this.floatingMenuOffset)) {
      this.isStickyFloatingMenu = true;
    } else {
      this.isStickyFloatingMenu = false;
    }
  }

  constructor(private coreServiceRegistry: CoreServiceRegistry, private sharedServiceRegistry: SharedServiceRegistry,
    public leftPanelService: LeftPanelService, private activatedRoute: ActivatedRoute) {
    this.navService = coreServiceRegistry.navigationService;
    this.resourceService = coreServiceRegistry.resourceService;
    this.userService = coreServiceRegistry.userService;
    this.alertService = sharedServiceRegistry.alertService;
    this.confirmDialogService = sharedServiceRegistry.confirmDialogService;
    this.userPreferenceService = sharedServiceRegistry.userPreferencesService;
    //  this.activatedRoute = coreServiceRegistry.activatedRoute;

    // Initializing Cell Data Map
    this.cellDataMap = {};
    this.subscriptionLists = [];
    this.title = this.resourceService.get('lbl_inventory_replenish');
    this.detailButtons = [
      new ButtonItem('Save', this.resourceService.get('btn_save'), '', 'floppy-disk', []),
      new ButtonItem('Edit Replenishment', this.resourceService.get('btn_edit'), 'replenishment_edit', 'pencil', []),
      new ButtonItem('Delete', this.resourceService.get('btn_delete'), 'replen_dtl_del', 'trash', [
        new ButtonItem('Delete Line item(s)', this.resourceService.get('btn_inv_rpln_delete_lineitem'), 'inv_repl_del_lineitem', 'trash', []),
        new ButtonItem('Delete All Line items', this.resourceService.get('btn_delete_all_lineitem'), 'inv_repl_del_all_lineitem', 'trash', []),
      ]),
      new ButtonItem('Post Replenishment', this.resourceService.get('btn_post_replenishment'), 'replen_post_dtl', 'icon-posting.svg', []),
    ];
    this.detailButtons[0].isEnabled = false;
    this.detailButtons[0].isVisible = false;
  }

  /**
   * Initializes the component
   */
  public ngOnInit() {
    this.initializeProperties();
    this.subscribeForEvents();
    const detailPagePresent = this.dataService.getEntityConfiguration().getDetailPageRoute();
    this.pageConfig.isPageLoaded = false;
    //   this.activatedRoute.params.subscribe(params => {
    //     this.navService.setPageTitle(this.entityConfig.getItemLabel().concat(' ').concat(this.resourceService.get('lbl_search')));
    // });
    if (detailPagePresent) {
      this.navService.setPageTitle(this.entityConfig.getItemLabel()
        .concat(' ').concat(this.resourceService.get('lbl_search')));
    } else {
      this.navService.setPageTitle(this.entityConfig.getItemLabel());
    }
    // Initialize the page once the metadata is available
    this.primarySearchService.fetchMetadata().subscribe(metadata => {
      this.initializePrimaryMetadataMap(metadata);
      this.cellDataMap = this.dataService.createNewRecord();
      this.initializePage();
      const searchServiceNew: any = this.dataService.getDetailsSearchService();
      this.dataService.tabbedSearchServices[0] = searchServiceNew;
      this.dataService.tabbedSearchServices[0].searchParams.actionButtons = this.detailButtons;
      this.pageConfig.isPageLoaded = true;
    });
  }

  /**
   * Initializes the component properties
   */
  private initializeProperties() {
    this.dataService = <InventoryReplenishDataService>this.serviceFactory.getDataService();
    this.actionService = <InventoryReplenishActionService>this.serviceFactory.getActionService();
    this.entityConfig = this.dataService.getEntityConfiguration();
    this.buttonService = <InventoryReplenishButtonService>this.serviceFactory.getButtonService();
    this.dataEditor = <InventoryReplenishDataEditorService>this.serviceFactory.getDataEditor();
    this.primarySearchService = this.dataService.getPrimarySearchService();
    if (this.entityConfig.formPageConfig.keyEventHandler) {
      this.keyEventHandler = this.entityConfig.formPageConfig.keyEventHandler;
    } else {
      this.keyEventHandler = new DetailViewKeyEventHandlerService(this.dataEditor);
    }

    this.pageConfig = this.dataService.entityConfig.formPageConfig;
    //    this.pageConfig.detailPageComponent = this;
    this.pageConfig.dataService = this.dataService;
    this.pageConfig.buttonService = this.buttonService;
    this.pageConfig.dataEditor = this.dataEditor;
    this.pageConfig.keyEventHandler = this.keyEventHandler;
    this.pageConfig.pageLabel = this.entityConfig.getItemLabel();
    this.pageConfig.showDetailsSection = this.entityConfig.getShowDetailLineItems();
  }

  // initializes the page.
  protected initializePage() {
    this.initializePrimarySection();
    // LFWM-3641- rebuilding the buttonArray
    this.buttonService.initializeSearchPageButtons();
    // For screens with line items in details page
    if (this.dataService.entityConfig.getShowDetailLineItems()) {
      this.initializeDetailTable();
    }
  }


  // loads the primary section which includes all accordian groups
  protected initializePrimarySection() {
    this.dataService.setPrimaryDataMap(this.cellDataMap);
    this.pageConfig.cellDataMap = this.cellDataMap;
    this.buttonService.initializeButtonsForPage(this.cellDataMap, 'details');
    if (this.entityConfig.getBreadCrumbPrefix()) {
      this.navService.addNonNavigableBreadCrumb(this.entityConfig.getBreadCrumbPrefix());
    }
    this.actionService.getStrategy();
    this.pageConfig.isPrimarySectionLoaded = true;
  }

  private initializePrimaryMetadataMap(metadata) {
    this.metadataMap = {};
    const columnsByGroup = {};
    this.columnGroupUserPreference = {};
    const columnGroupWidgetList: Array<LFDynamicWidgetConfig> = [];

    // Metadata for Primary & Secondary Accordions are readily available in Primary Search Service
    metadata.columnList.map((column: any) => {
      // Metadata.columnList is iterated and categorized based on columnGroup
      if (!columnsByGroup[column.columnGroup]) {
        columnsByGroup[column.columnGroup] = [];
        if (column.columnGroup !== 'Primary' && column.columnGroup !== 'ACCORDION') {
          this.columnGroupUserPreference[column.columnGroup] = Object.keys(this.columnGroupUserPreference).length;
        }
      }
      columnsByGroup[column.columnGroup].push(column.propertyName);
      this.metadataMap[column.propertyName] = column;
    });
    this.tablePreference = this.primarySearchService.getTablePreference();
    const favourite = this.tablePreference['favouriteConfig']['configuration'];
    this.favouriteIconFlag = favourite['favourite'];
    this.pageConfig.userPreference = this.tablePreference;
    if (Object.keys(this.tablePreference.columGroupConfig.configuration).length === 0) {
      this.tablePreference.columGroupConfig.configuration = this.columnGroupUserPreference;
    } else {
      this.columnGroupUserPreference = this.tablePreference.columGroupConfig.configuration;
    }
    Object.keys(columnsByGroup).forEach((columnGroup: any) => {
      // if the column group name is ACCORDION, then do not show it
      if (columnGroup === 'ACCORDION') {
        return;
      }
      const columnGroupWidget = new LFDynamicWidgetConfig();
      columnGroupWidget.id = columnGroup;
      columnGroupWidget.columnGroup = columnGroup;
      columnGroupWidget.propertyList = columnsByGroup[columnGroup];
      columnGroupWidget.name = this.resourceService.get(columnGroup);
      columnGroupWidget.activeIndex = this.columnGroupUserPreference[columnGroup];
      //      columnGroupWidget.widgetType = (columnGroup === 'Primary') ? 'P' : 'S';
      columnGroupWidgetList.push(columnGroupWidget);
    });

    // if there is no default accordion specified, initialize a default one
    if (this.entityConfig.showDetailLineItems) {
      const detailWidget = new LFDynamicWidgetConfig();
      detailWidget.id = 'Details';
      detailWidget.name = 'Details';
      columnGroupWidgetList.push(detailWidget);
    }

    // this.customizeMetadataMap();
    this.dataService.primaryMetaDataMap = this.metadataMap;
    this.pageConfig.metaDataMap = this.metadataMap;
    this.dataService.primaryColumnGrouping = columnsByGroup;
    this.columnGroupWidgetList = columnGroupWidgetList;
    // the below code is added to override the metadata object
    this.dataService.overrideMetadataMap(this.dataService.displayMode);
  }

   // Method to Customize Metadata for Display Only Changes
  private customizeMetadataMap() {
    // Overriding Metadata for facility to display it in ['Key - Value'] format
    // Below, Deep Clone has to be performed to avoid directly updating Metadata Object in Service
    // LFWM - 2709 - display value from metadata which is in key value format
    // if (!this.metadataMap['facility']) {
    //   return;
    // }
    // const facilityMetadata = JSON.parse(JSON.stringify(this.metadataMap['facility']));
    // facilityMetadata.values.forEach((option) => {
    //   option.value = option.key + ' - ' + option.value;
    // });
    // this.metadataMap['facility'] = facilityMetadata;
  }

  public getBreadCrumbText() {
    if (this.dataService.getPrimarySelectedDocument()) {
      this.selectedValue = this.entityConfig.getBreadCrumbPrefix() + this.dataService.getPrimarySelectedDocument();
      this.showBreadcrumbLabel = true;
      return true;
    }
  }

  // initializes the line item detail table
  public initializeDetailTable() {

    // if the retainState flag is set, do not reinitialize the service. Use the service already loaded in the memory
    if (!this.retainState || !this.dataService.getDetailsSearchService()) {
      this.dataService.initializeDetailsSearchContext();
    }
    this.detailsSearchService = this.dataService.getDetailsSearchService();
    //LFWM-3363 resetting the max line number for every new detail table
    this.dataService.maxIdValueForDetailTable = '';
    const metadataSubscription = this.detailsSearchService.fetchMetadata().subscribe((metadata) => {
      metadata.columnList.sort((a, b) => {
        return a.index - b.index;
      });
      this.pageConfig.isDetailSectionLoaded = true;
      // this.showDetailsSection = true;
      this.expandDetailsSection = true;
    });
    this.subscriptionLists.push(metadataSubscription);

    // Subscription for the Search Events from Details Search Service.
    const detailsSearchEventSubscription = this.detailsSearchService.receiveEvent()
      .subscribe((event: SearchEvent) => {
        this.buttonService.initializeButtonsForPage(this.cellDataMap, 'details');
        if (event.type === NEW_SEARCH_EVENT && this.detailsSearchService.getMetadata()) {
          // For NEW_SEARCH_EVENT, the Details Data Table will be displayed
          this.pageConfig.isDetailSectionLoaded = true;
        } else if (event.type === NEW_ROW_EVENT) {
          // For NEW_ROW_EVENT
          this.dataService.handleAddNewLineItem(event);
        } else if (event.type === PAGE_OVERFLOW_EVENT) {
          // This event comes when a page overflow has occured. Save the corrent page and navigate to the next
          // page on success
          this.detailsSearchService.setNewPageEventInProgress(true);
          this.buttonService.performButtonActions('Save');
        }
      });
    this.subscriptionLists.push(detailsSearchEventSubscription);
  }

  private subscribeForEvents() {
    this.userPreferenceEventSubscription = this.userPreferenceService.receiveEvent()
      .subscribe((event: UserPreferenceEvent) => {
        if (event.source === 'search') {
          // if this event originated from the search page, ignore it. It will be handled separately
          return;
        }
        if (event.type === DELETE_FAVOURITE) {
          // if the user is on the same page as that of the table to be removed from favourites list from side panel
          // Fix for LFWM 1213
          if (event.preferenceId === this.tablePreference.favouriteConfig.preferenceId) {
            this.favouriteIconFlag = false;
          }
          // this.userPreferences.preferenceId = null;
        } else if (event.type === ADD_FAVOURITE) {
          this.favouriteIconFlag = true;
        }
      });
  }
  // method used to translate the labels
  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

  // Method to return Cell Title corresponding to each property
  public getCellTitle(property: any): string {
    return this.resourceService.get(this.metadataMap[property].elementId);
  }

  // Method  to override default display format for each cell value (in VIEW Mode ONLY)
  public getCellDisplayValue(property: any): any {
    return ''; // this.dataService.getCellDisplayValue(property, this.isLoading);
  }

  private openLookup(cells: any, property: any) {
    const row = { cells: this.cellDataMap };
    this.dataEditor.openLookup(row, property);
  }

  // method to handle cell change
  public handleCellChange(event: any) {
    if (event.eventType === 'CELL_VALUE_CHANGED' && event.value) {
      /* Adding the below code as the user should not be permitted to change the header status to 'Finalized'
          and save the adjustment ticket, user should only finalize the adjustment using Finalize adjustment action*/
      if (event.value.cName === 'finalizedflag' && event.value.cVal === 'Y') {
        this.alertService.clearAll().error('err_chg_fin_adj');
        return;
      }
      if (event.value.cName === 'finalizedflag' && (event.value.cVal === 'A' || event.value.cVal === 'R')) {
        const adjustmentKey = this.dataService.getPrimaryDataIdValue();
        this.dataEditor.updateDetailStatus(adjustmentKey);
      }
    }
  }
  // add/remove favorite config
  public toggleFavourites() {
    // if the page is set as favourite
    if (this.favouriteIconFlag === false) {
      const userPreferences = {
        dataTableId: this.primarySearchService.searchParams.tableId,
        prefType: 'FAVOURITECONFIG',
        configuration: { 'favourite': true }
      };
      this.userPreferenceService.saveTablePreferences(userPreferences).subscribe((data: any) => {
        this.favouriteIconFlag = true;
        this.tablePreference.favouriteConfig = data;
        //   this.userPreferences.preferenceId = data['preferenceId'];
        this.notifyUserPreferenceEvent(ADD_FAVOURITE);
        this.alertService.success(this.resourceService.get('msg_fav_add'));
      }, (error: any) => {
        this.alertService.clearAll().error(this.resourceService.get(error.error.errors['0'].validationMessage));
      });
    } else {
      this.userPreferenceService.deleteFavorites(this.tablePreference.favouriteConfig.preferenceId).subscribe((data: any) => {
        this.favouriteIconFlag = false;
        this.tablePreference.favouriteConfig = null;
        this.alertService.success(this.resourceService.get('msg_fav_del'));
        this.notifyUserPreferenceEvent(DELETE_FAVOURITE);
      });
    }
  }

  private notifyUserPreferenceEvent(type: number, isExternal?: boolean) {
    const event = new UserPreferenceEvent();
    event.type = type;
    event.source = 'search';
    event.preferenceId = type;
    if (isExternal) {
      event.isExternal = isExternal;
    }
    this.userPreferenceService.notifyEvent(event);
  }

  public ngOnDestroy() {
    if (this.subscriptionLists) {
      this.subscriptionLists.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
    if (this.userPreferenceEventSubscription) {
      this.userPreferenceEventSubscription.unsubscribe();
    }
  }

  public togglePrimaryAccordion() {
    this.expandPrimaryAccordion = !this.expandPrimaryAccordion;
  }

  public toggleDetailsAccordion() {
    this.expandDetailsAccordion = !this.expandDetailsAccordion;
  }



  // new changes start from here
  public onTabChange(tabIndex) {
    this.dataService.tabbedSearchServices[0].searchParams.actionButtons = this.detailButtons;
    this.selectedTab = tabIndex;
    this.initializeSearchServices(tabIndex);
  }

  // Upon changing hte tab we need to swap  the search services
  private initializeSearchServices(tabIndex) {
    if (!this.selectedTab) {
      this.selectedTab = 0;
    }
    if ((tabIndex === 0) || (tabIndex === '0')) {
      this.dataService.tabbedSearchServices[0].searchParams.actionButtons = this.detailButtons;
      // This will call the load by page of detail tab
      this.actionService.viewReplenishment('detail', 0);

    } else {
      if (!this.dataService.tabbedSearchServices[1]) {
        this.dataService.tabbedSearchServices[1] = this.dataService.getDetailsSearchService();
        this.dataService.tabbedSearchServices[1].searchParams.actionButtons = [];
      }
      // This will call the load by page of replenishment tab
      this.actionService.viewReplenishment('non-detail', 1);
    }


  }

  // on clicking Edit we have to have the edit button disabled and save button enabled
  private refreshButtons() {
    this.detailButtons.forEach((button: ButtonItem) => {
      switch (button.action) {
        case 'Edit Replenishment': {
          button.isEnabled = (this.dataService.displayMode === 'V');
          button.isVisible = (this.dataService.displayMode === 'V');
          break;
        }
        case 'Save': {
          button.isEnabled = (this.dataService.displayMode === 'E');
          button.isVisible = (this.dataService.displayMode === 'E');
          break;
        }

      }
    });
  }
  public handleButtonAction(action: string) {
    if (action === 'Edit Replenishment') {
      this.dataService.displayMode = 'E';
      this.refreshButtons();
      this.dataService.tabbedSearchServices[0].setDisplayMode('E');
    } else if (action === 'Save') {
      this.dataService.displayMode = 'V';
      this.dataService.tabbedSearchServices[0].setDisplayMode('V');
      this.actionService.saveAfterEdit();
      this.refreshButtons();
    } else if (action === 'Delete Line item(s)') {
      const selectedRows: any = this.dataService.tabbedSearchServices[0].getSelectedRows();
      const noLineSelectedMessage: string = 'msg_sel_detail';
      if (selectedRows.length === 0) {
        this.alertService.error(this.resourceService.get(noLineSelectedMessage));
        return;
      }
      const nonSelctedRows: any = this.dataService.tabbedSearchServices[0].getNonSelectedRows();
      this.dataService.tabbedSearchServices[0].setPagedRows(nonSelctedRows);
      const replenishKeys: Array<string> = [];
      for (let i = 0; i < selectedRows.length; i++) {
        selectedRows[i]['isSelected'] = false;
        replenishKeys.push(selectedRows[i]['cells']['replenishKey'].cVal);
      }
      // this.dataService.tabbedSearchServices[1].setPagedData(selectedRows);
      this.actionService.deleteDetail(replenishKeys);
    } else if (action === 'Delete All Line items') {
      let rowsLength = this.dataService.tabbedSearchServices[0].getAllRows().length;
      if (rowsLength > 0 ) {
        this.confirmDialogService.confirmDialog('Are you sure you want to delete all line items ?')
        .subscribe((isConfirmed: any) => {
          if (isConfirmed) {
            this.actionService.deleteAllLineitems();
          }
        });
      } else {
        this.alertService.clearAll().warn(this.resourceService.get('msg_no_row_view_inv-replensih'));
      }
    } else if (action === 'Post Replenishment') {
      const replenishKeys: Array<string> = [];
      const selectedRows: any = this.dataService.tabbedSearchServices[0].getSelectedRows();
      const noLineSelectedMessage: string = 'msg_sel_detail';
      const isFromStatic = true;
      if (selectedRows.length === 0) {
        this.alertService.error(this.resourceService.get(noLineSelectedMessage));
        return;
      }else {
        this.actionService.dialogMsg = 'msg_post_confirm';
        if (this.dataService.tabbedSearchServices[0].getPagedData().pageRows.length > 0) {
          // LFWM 3576 without confirming also the record was deleting
          this.confirmDialogService.confirmDialog(this.resourceService.get(this.actionService.dialogMsg))
            .subscribe((isConfirmed: any) => {
              if (isConfirmed) {
                const nonSelctedRows: any = this.dataService.tabbedSearchServices[0].getNonSelectedRows();
                this.dataService.tabbedSearchServices[0].setPagedRows(nonSelctedRows);
                this.dataService.tabbedSearchServices[0].getPagedData().pageDefinition.recordCount =
                  this.dataService.tabbedSearchServices[0].getPagedData().pageDefinition.recordCount
                  - selectedRows.length;
                const evt = new SearchEvent(DELETE_ROW_EVENT);
                this.dataService.tabbedSearchServices[0].publishEvent(evt);
                if (!this.dataService.tabbedSearchServices[1]) {
                  this.dataService.tabbedSearchServices[1] = this.dataService.getDetailsSearchService();
                }
                for (let i = 0; i < selectedRows.length; i++) {
                  selectedRows[i]['isSelected'] = false;
                  replenishKeys.push(selectedRows[i]['cells']['replenishKey'].cVal);
                }
                const newPagedRows: any = this.dataService.tabbedSearchServices[1].getPagedData().pageRows;
                newPagedRows.push(selectedRows);
                this.dataService.tabbedSearchServices[1].setPagedRows(newPagedRows);
                this.actionService.postReplenishment(replenishKeys, isFromStatic);
              }else {
                return;
              }
            });
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/inventory/inventory-replenish/inventory-static-form-page/inventory-static-form-page.component.ts